import axios from "axios";

// Single axios instance for the app. withCredentials sends the session cookie.
// REACT_APP_BACKEND_URL is empty when the API is served from the same domain
// (public_html/api on Hostinger), which makes the base URL a plain "/api".
export const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});
